import { screenSizes } from '@lux/tokens';
import { FACEBOOK_DEPRECATION_PAGE, FB_POPUP_COOKIE_EXPIRATION_IN_DAY, DEPRECATION_WARNING_CLOSED_COOKIE_NAME, } from '../constants';
import { setCookie, getCookie } from './cookie';
export const removePadding = (str) => str.replace(/(=+)$/, '');
export const getEncodedValueOf = (data) => {
    return window.btoa(unescape(encodeURIComponent(data)));
};
export const isFacebookDeprecationPageShown = () => window.location.href.includes(FACEBOOK_DEPRECATION_PAGE);
export const setFbPopupCookie = () => {
    setCookie(DEPRECATION_WARNING_CLOSED_COOKIE_NAME, 'true', FB_POPUP_COOKIE_EXPIRATION_IN_DAY);
};
export const isDeprecationOverlayClosedByCustomer = () => {
    const isCustomerClosed = getCookie(DEPRECATION_WARNING_CLOSED_COOKIE_NAME);
    return isCustomerClosed === 'true';
};
export const isClient = () => typeof window !== 'undefined';
const getWindowWidth = () => isClient() &&
    (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);
export const isMobileScreenSize = () => getWindowWidth() < screenSizes.sm;
//# sourceMappingURL=utils.js.map